/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    BadgeOutlined,
    CampaignOutlined, DescriptionOutlined,
    EmojiNatureOutlined,
    GroupOutlined,
    PointOfSaleOutlined,
    PostAddOutlined,
    RealEstateAgentOutlined,
    ReviewsOutlined,
    SurfingOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Anuncios from "./Secciones/Seccion_Anuncios";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Servicios from "./Secciones/Seccion_Servicios";
import Seccion_Testimonios from "./Secciones/Seccion_Testimonios";
import Seccion_Tours from "./Secciones/Seccion_Tours";
import Seccion_Sostenibilidad from "./Secciones/Seccion_Sostenibilidad";
import Seccion_Adicionales from "./Secciones/Seccion_Adicionales";
import Seccion_Personal from "./Secciones/Seccion_Personal";
import Seccion_Pagos from "./Secciones/Seccion_Pagos";
import Seccion_Certificados from "./Secciones/Seccion_Certificados";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [

    {
        nombre: 'Cobros',
        icono: PointOfSaleOutlined,
        camino: '/Cobros',
        categoria: 'Finanzas',
        Componente: <Seccion_Pagos/>
    },
    {
        nombre: 'Anuncios',
        icono: CampaignOutlined,
        camino: '/Anuncios',
        categoria: 'Pagina',
        Componente: <Seccion_Anuncios/>
    },
    {
        nombre: 'Servicios',
        icono: RealEstateAgentOutlined,
        camino: '/Servicios',
        categoria: 'Pagina',
        Componente: <Seccion_Servicios/>
    },
    {
        nombre: 'Testimonios',
        icono: ReviewsOutlined,
        camino: '/Testimonios',
        categoria: 'Pagina',
        Componente: <Seccion_Testimonios/>
    },
    {
        nombre: 'Tours',
        icono: SurfingOutlined,
        camino: '/Tours',
        categoria: 'Pagina',
        Componente: <Seccion_Tours/>
    },
    {
        nombre: 'Sostenibilidad',
        icono: EmojiNatureOutlined,
        camino: '/Sostenibilidad',
        categoria: 'Pagina',
        Componente: <Seccion_Sostenibilidad/>
    },
    {
        nombre: 'Personal',
        icono: GroupOutlined,
        camino: '/Personal',
        categoria: 'Pagina',
        Componente: <Seccion_Personal/>
    },
    {
        nombre: 'Certificados',
        icono: DescriptionOutlined,
        camino: '/Certificados',
        categoria: 'Pagina',
        Componente: <Seccion_Certificados/>
    },
    {
        nombre: 'Adicionales',
        icono: PostAddOutlined,
        camino: '/Adicionales',
        categoria: 'Pagina',
        Componente: <Seccion_Adicionales/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: true,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}